import { Model } from '@vuex-orm/core'

import {Channel} from './Channel'
import {MaterialCategory, MaterialAppearance} from './Material'

export default class Workspace extends Model {
  static entity = 'workspaces'
  static primaryKey = ['channel_id', 'id']

  static fields () {
    return {
      id: this.attr(null),
      channel_id: this.attr(null),
      name: this.attr(null),
      onair: this.attr(null),
      config: this.attr(null),
      channel: this.belongsTo(Channel, 'channel_id')
    }
  }
}
